module.exports = __webpack_public_path__ + "media/images/frame-d5c48f474857bae0a5c06d39cb6e78cb.svg";